// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search_wrapper__uyEZw","search":"search_search__BT7T7","reset":"search_reset__V6CKM"};